"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EditableContent;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useDeepCompare = require("use-deep-compare");

var _contenteditableArrowNavigation = require("contenteditable-arrow-navigation");

var _useParseSectionsContent = _interopRequireDefault(require("../hooks/useParseSectionsContent"));

var _detectRTL = require("../helpers/detectRTL");

var _EditableSection = _interopRequireDefault(require("./EditableSection"));

var _excluded = ["children", "content"],
    _excluded2 = ["content", "onContent", "components", "parsers", "joiners", "decorators", "sectionIndex", "verbose"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DEFAULT_PROPS = {
  content: '',
  onContent: function onContent(content) {
    console.warn('EditableContent.onContent() not provided:\n\n', content);
  },
  options: {
    sectionable: true,
    blockable: true,
    editable: true,
    preview: false
  },
  components: {
    document: function document(_ref) {
      var children = _ref.children,
          content = _ref.content,
          props = _objectWithoutProperties(_ref, _excluded);

      return /*#__PURE__*/_react.default.createElement("div", _extends({
        className: "document"
      }, props), children);
    }
  },
  parsers: {
    section: function section(content) {
      return content.split('\n\n');
    },
    block: function block(content) {
      return content.split('\n');
    }
  },
  joiners: {
    section: '\n\n',
    block: '\n'
  },
  handlers: {
    onSectionClick: function onSectionClick(_ref2) {
      var content = _ref2.content,
          index = _ref2.index;
      console.warn('EditableContent.onSectionClick({content, index}) not provided:\n\n', index);
    },
    onBlockClick: function onBlockClick(_ref3) {
      var content = _ref3.content,
          index = _ref3.index;
      console.warn('EditableContent.onBlockClick({content, index}) not provided.\n\n', index);
    }
  },
  sectionIndex: 0
};

function EditableContent(_ref4) {
  var content = _ref4.content,
      onContent = _ref4.onContent,
      _components = _ref4.components,
      parsers = _ref4.parsers,
      joiners = _ref4.joiners,
      decorators = _ref4.decorators,
      sectionIndex = _ref4.sectionIndex,
      _ref4$verbose = _ref4.verbose,
      verbose = _ref4$verbose === void 0 ? false : _ref4$verbose,
      props = _objectWithoutProperties(_ref4, _excluded2);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  var components = (0, _react.useMemo)(function () {
    return _objectSpread(_objectSpread({}, DEFAULT_PROPS.components), _components);
  }, []); // without empty dep for useMemo, components rerender from scratch every time.

  var Document = components.document;

  var options = _objectSpread(_objectSpread({}, DEFAULT_PROPS.options), props.options);

  var handlers = _objectSpread(_objectSpread({}, DEFAULT_PROPS.handlers), props.handlers);

  (0, _react.useEffect)(function () {
    if (verbose) console.log('EditableContent First Render'); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  (0, _useDeepCompare.useDeepCompareEffect)(function () {
    (0, _contenteditableArrowNavigation.addArrowKeyNavigationToContenteditableElements)();
  }, [options, content]);
  var sectionsContent = (0, _useParseSectionsContent.default)({
    content: content,
    parsers: parsers,
    options: options
  });
  var onSectionEdit = (0, _useDeepCompare.useDeepCompareCallback)(function (section, index) {
    var _sections = _toConsumableArray(sectionsContent);

    _sections[index] = section;

    var _content = _sections.join(joiners.section);

    onContent(_content);
  }, [sectionsContent, onContent]);
  var sectionsComponents = (0, _useDeepCompare.useDeepCompareMemo)(function () {
    var _sectionsComponents;

    var dir = (0, _detectRTL.isRtl)(content) ? 'rtl' : '';
    _sectionsComponents = sectionsContent.map(function (sectionContent, index) {
      var sectionProps = {
        content: sectionContent,
        onContent: function onContent(_section) {
          onSectionEdit(_section, index);
        },
        show: !options.sectionable || sectionIndex === -1 || index === sectionIndex,
        onShow: function onShow() {
          handlers.onSectionClick({
            content: sectionContent,
            index: index
          });
        },
        index: index,
        components: components,
        options: options,
        parsers: parsers,
        joiners: joiners,
        handlers: handlers,
        decorators: decorators,
        dir: dir,
        verbose: verbose
      };
      return /*#__PURE__*/_react.default.createElement(_EditableSection.default, _extends({
        key: index
      }, sectionProps));
    });
    return _sectionsComponents;
  }, [sectionsContent, options, parsers, joiners, decorators, handlers, sectionIndex]);

  var documentProps = _objectSpread({
    content: content,
    className: options.preview ? 'preview' : ''
  }, props);

  return /*#__PURE__*/_react.default.createElement(Document, _extends({
    key: "1"
  }, documentProps), sectionsComponents);
}

;
EditableContent.propTypes = {
  /** Text to be edited whether file, section or block */
  content: _propTypes.default.string.isRequired,

  /** Function triggered on edit */
  onContent: _propTypes.default.func,

  /** Options for the editor */
  options: _propTypes.default.shape({
    /** Parse content by sections using sectionParser */
    sectionable: _propTypes.default.bool,

    /** Parse content by blocks using blockParser */
    blockable: _propTypes.default.bool,

    /** Editable? */
    editable: _propTypes.default.bool,

    /** Preview? */
    preview: _propTypes.default.bool
  }),

  /** Components to wrap all sections of the document */
  components: _propTypes.default.shape({
    /** Component to wrap all sections of the document */
    document: _propTypes.default.func,

    /** Component to be the section wrapper */
    section: _propTypes.default.func,

    /** Component to wrap the first line of a section */
    sectionHeading: _propTypes.default.func,

    /** Component to be the section body */
    sectionBody: _propTypes.default.func,

    /** Component to be the block editor */
    block: _propTypes.default.func
  }),

  /** Functions to parse the content into sections and blocks */
  parsers: _propTypes.default.shape({
    /** Function to parse the content into sections */
    section: _propTypes.default.func,

    /** Function to parse the content into blocks */
    block: _propTypes.default.func
  }),

  /** Strings to join the blocks to content */
  joiners: _propTypes.default.shape({
    /** String to join the sections to content */
    section: _propTypes.default.string,

    /** String to join the blocks to content */
    block: _propTypes.default.string
  }),

  /** Object of replacers for html/css decoration of content, done at block level */
  decorators: _propTypes.default.object,

  /** Callback handlers such as block and section click */
  handlers: _propTypes.default.shape({
    /** Callback triggered on Section Heading click, provides section content and index. */
    onSectionClick: _propTypes.default.func,

    /** Callback triggered on Block click, provides block content and index. */
    onBlockClick: _propTypes.default.func
  }),

  /** Index of section to be show, for app to manage state. -1 to show all. */
  sectionIndex: _propTypes.default.number,

  /** Flag to enable logging  */
  verbose: _propTypes.default.bool
};
EditableContent.defaultProps = DEFAULT_PROPS;